/**
 * 管理员页面搜索和分页处理 Hook
 */
import { useCallback } from "react";

export interface UseAdminSearchAndPaginationProps {
  searchParams: any;
  setSearchParams: (params: any) => void;
  pagination: { current: number; pageSize: number };
  setPagination: (pagination: { current: number; pageSize: number }) => void;
  fetchAdminList: (params: any) => Promise<void>;
}

export const useAdminSearchAndPagination = ({
  searchParams,
  setSearchParams,
  pagination,
  setPagination,
  fetchAdminList,
}: UseAdminSearchAndPaginationProps) => {
  // 搜索处理
  const handleSearch = useCallback(
    async (params: any = {}) => {
      const searchData = { ...searchParams, ...params };
      setSearchParams(searchData);
      const paginationData = {
        page: pagination.current,
        pageSize: pagination.pageSize,
        ...searchData,
      };
      await fetchAdminList(paginationData);
    },
    [searchParams, pagination, setSearchParams, fetchAdminList]
  );

  // 重置搜索
  const handleReset = useCallback(() => {
    setSearchParams({});
    setPagination({ current: 1, pageSize: 10 });
    fetchAdminList({ page: 1, pageSize: 10 });
  }, [setSearchParams, setPagination, fetchAdminList]);

  // 分页处理
  const handlePaginationChange = useCallback(
    (paginationInfo: any) => {
      const newPagination = {
        current: paginationInfo.current,
        pageSize: paginationInfo.pageSize,
      };
      setPagination(newPagination);
      const paginationData = {
        page: paginationInfo.current,
        pageSize: paginationInfo.pageSize,
        ...searchParams,
      };
      fetchAdminList(paginationData);
    },
    [setPagination, searchParams, fetchAdminList]
  );

  return {
    handleSearch,
    handleReset,
    handlePaginationChange,
  };
};

